(() => {
  const readJSON = (node, fallback = {}) => {
    try { return JSON.parse(node?.textContent || ''); } catch { return fallback; }
  };
  const grams = (variant) => {
    for (const option of [...(variant.options || []), variant.title]) {
      const match = String(option || '').trim().match(/^(\d+(?:\.\d+)?)\s*(kg|kilograms?|kilos?|g|gm|grams?)\b/i);
      if (match) return Number(match[1]) * (/^(kg|kilo)/i.test(match[2]) ? 1000 : 1);
    }
    return null;
  };
  const categoryKeys = (product) => (product.tags || []).filter(t => t.toLowerCase().startsWith('b2b-category:')).map(t => t.slice(13).toLowerCase().trim());
  const variantFor = (product, state) => {
    const eligible = (product.variants || []).filter(v => (!state.stock || v.available)
      && (state.pack === 'any' || state.pack === 'bulk' || grams(v) === Number(state.pack))
      && (state.pack === 'bulk' || ((state.min === null || v.price / 100 >= state.min) && (state.max === null || v.price / 100 <= state.max))));
    return eligible.sort((a, b) => Number(b.available) - Number(a.available) || a.price - b.price)[0] || null;
  };
  const matches = (product, state) => {
    if (state.category !== 'all' && !categoryKeys(product).includes(state.category)) return null;
    if (state.keyword && ![product.title, product.type, ...(product.tags || [])].join(' ').toLowerCase().includes(state.keyword.toLowerCase().trim())) return null;
    const variant = variantFor(product, state);
    if (!variant) return null;
    if (state.pack !== 'bulk' && ((state.min !== null && variant.price / 100 < state.min) || (state.max !== null && variant.price / 100 > state.max))) return null;
    return { product, variant };
  };
  const node = (tag, className, text) => {
    const result = document.createElement(tag);
    if (className) result.className = className;
    if (text !== undefined) result.textContent = text;
    return result;
  };
  const prefill = (ingredient, quantity) => {
    document.querySelectorAll('[data-enquiry-body]').forEach(input => { if (ingredient) input.value = ingredient; });
    document.querySelectorAll('[data-enquiry-quantity]').forEach(input => { if (quantity !== undefined) input.value = quantity; });
  };
  const productCard = ({ product, variant }, state, labels) => {
    const article = node('article', 'tbb-product-card');
    const imageLink = node('a', 'tbb-product-card__image');
    const productURL = new URL(product.url, location.origin);
    productURL.searchParams.set('variant', variant.id);
    imageLink.href = productURL.pathname + productURL.search;
    const img = node('img');
    img.src = product.image || labels.images?.[product.type] || labels.fallback;
    img.alt = product.image ? product.title : (product.type || labels.raw) + ' category photograph';
    img.width = 700; img.height = 700; img.loading = 'lazy';
    imageLink.append(img);
    const copy = node('div', 'tbb-product-card__copy');
    copy.append(node('p', 'tbb-eyebrow', product.type || labels.raw));
    const heading = node('h3');
    const title = node('a', '', product.title); title.href = imageLink.href; heading.append(title); copy.append(heading);
    if (state.pack !== 'bulk') {
      const price = node('p', '', variant.formatted.replace(/<[^>]*>/g, ''));
      copy.append(price);
      if (variant.title !== 'Default Title') copy.append(node('p', 'tbb-small', variant.title));
    } else copy.append(node('p', 'tbb-small', labels.bulk));
    const action = node('a', 'tbb-text-link', `${state.pack === 'bulk' ? labels.quote : variant.available ? labels.view : labels.enquire} ↗`);
    if (state.pack === 'bulk' || !variant.available) {
      const quoteURL = new URL(labels.quoteUrl || '/pages/bulk-enquiry', location.href);
      quoteURL.searchParams.set('ingredient', product.title);
      if (state.pack !== 'bulk') quoteURL.searchParams.set('quantity', state.pack === 'any' ? variant.title : state.pack + ' g');
      quoteURL.hash = 'b2b-enquiry';
      action.href = quoteURL.pathname + quoteURL.search + quoteURL.hash;
      action.addEventListener('click', () => prefill(product.title, state.pack === 'bulk' ? '' : `${state.pack === 'any' ? variant.title : state.pack + ' g'}`));
    } else action.href = imageLink.href;
    copy.append(action); article.append(imageLink, copy);
    return article;
  };
  const initialise = (section) => {
    if (section.dataset.tbbInitialised) return;
    section.dataset.tbbInitialised = 'true';
    const catalogue = readJSON(section.querySelector('[data-catalogue]'), { products: [], next: null });
    const labels = readJSON(section.querySelector('[data-finder-labels]'));
    const products = new Map((catalogue.products || []).map(p => [String(p.id), p]));
    const results = section.querySelector('[data-results]');
    const state = { category: 'all', pack: 'any', min: null, max: null, keyword: '', stock: false, limit: 12 };
    const fields = Object.fromEntries(['keyword', 'pack', 'min', 'max', 'stock'].map(k => [k, section.querySelector(`[data-${k}]`)]));
    const loading = section.querySelector('[data-loading]');
    const error = section.querySelector('[data-error]');
    const empty = section.querySelector('[data-empty]');
    const count = section.querySelector('[data-result-count]');
    const more = section.querySelector('[data-show-more]');
    const priceError = section.querySelector('[data-price-error]');
    let next = catalogue.next;
    let pending = false;
    const refresh = () => {
      state.keyword = fields.keyword.value;
      state.pack = fields.pack.value;
      state.min = fields.min.value === '' ? null : Number(fields.min.value);
      state.max = fields.max.value === '' ? null : Number(fields.max.value);
      state.stock = fields.stock.checked;
      fields.min.disabled = state.pack === 'bulk'; fields.max.disabled = state.pack === 'bulk';
      const invalid = state.pack !== 'bulk' && state.min !== null && state.max !== null && state.min > state.max;
      priceError.hidden = !invalid;
      const found = invalid ? [] : [...products.values()].map(p => matches(p, state)).filter(Boolean);
      results.replaceChildren(...found.slice(0, state.limit).map(p => productCard(p, state, labels)));
      count.textContent = found.length === 1 ? labels.one : labels.many.replace('__COUNT__', found.length);
      empty.hidden = found.length > 0 || pending || invalid;
      more.hidden = state.limit >= found.length;
      const emptyQuote = new URL(labels.quoteUrl || '/pages/bulk-enquiry', location.href);
      emptyQuote.searchParams.set('ingredient', [state.keyword, state.category === 'all' ? '' : state.category].filter(Boolean).join(' · '));
      if (state.pack !== 'bulk' && state.pack !== 'any') emptyQuote.searchParams.set('quantity', `${state.pack} g`);
      emptyQuote.hash = 'b2b-enquiry';
      section.querySelector('[data-empty-quote]').href = emptyQuote.pathname + emptyQuote.search + emptyQuote.hash;
    };
    const category = (key) => {
      const known = section.querySelector(`[data-category="${CSS.escape(key)}"]`);
      state.category = known ? key : 'all';
      state.limit = 12;
      section.querySelectorAll('[data-category]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.category === state.category)));
      refresh();
    };
    section.tbbChoose = (key, keyword) => {
      if (keyword !== undefined) fields.keyword.value = keyword;
      if (key) category(key); else { state.limit = 12; refresh(); }
      section.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    };
    section.querySelectorAll('[data-category]').forEach(button => button.addEventListener('click', () => category(button.dataset.category)));
    section.querySelector('[data-filters]').addEventListener('submit', event => event.preventDefault());
    section.querySelector('[data-filters]').addEventListener('input', event => {
      if (event.target.tagName === 'SELECT' || event.target.type === 'checkbox') return;
      state.limit = 12; refresh();
    });
    section.querySelector('[data-filters]').addEventListener('change', event => {
      if (event.target.tagName !== 'SELECT' && event.target.type !== 'checkbox') return;
      state.limit = 12; refresh();
    });
    section.querySelector('[data-reset]').addEventListener('click', () => {
      fields.keyword.value = ''; fields.pack.value = 'any'; fields.min.value = ''; fields.max.value = ''; fields.stock.checked = false; category('all');
    });
    more.addEventListener('click', () => { state.limit += 12; refresh(); });
    const load = async () => {
      if (pending || !next) return;
      pending = true; loading.hidden = false; error.hidden = true; refresh();
      try {
        while (next && section.isConnected) {
          const url = new URL(next, location.origin);
          if (url.origin !== location.origin) throw new Error('Invalid catalogue origin');
          url.searchParams.set('section_id', section.dataset.sectionId);
          const response = await fetch(url, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Catalogue unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const batchNode = doc.querySelector('[data-catalogue]');
          if (!batchNode) throw new Error('Catalogue data missing');
          const batch = JSON.parse(batchNode.textContent);
          if (batch.next === next) throw new Error('Catalogue pagination did not advance');
          (batch.products || []).forEach(p => products.set(String(p.id), p));
          next = batch.next; refresh();
        }
      } catch { error.hidden = false; }
      finally { pending = false; loading.hidden = true; refresh(); }
    };
    section.querySelector('[data-retry]').addEventListener('click', load);
    const params = new URLSearchParams(location.search);
    fields.keyword.value = params.get('ingredient') || params.get('q') || '';
    category(params.get('category') || 'all');
    load();
  };
  const initialiseAll = () => {
    document.querySelectorAll('[data-tbb-finder]').forEach(initialise);
    const params = new URLSearchParams(location.search);
    if (document.querySelector('[data-enquiry-body]')) prefill(params.get('ingredient') || '', params.get('quantity') || '');
  };
  document.addEventListener('click', event => {
    const anchor = event.target.closest('[data-tbb-category-link], [data-tbb-ingredient-link]');
    if (anchor && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      const finder = document.querySelector('[data-tbb-finder]');
      if (finder?.tbbChoose && new URL(anchor.href, location.href).pathname === location.pathname) { event.preventDefault(); finder.tbbChoose(anchor.dataset.tbbCategoryLink || null, anchor.dataset.tbbIngredientLink); }
    }
    document.querySelectorAll('[data-tbb-menu][open]').forEach(menu => {
      if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
    });
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('[data-tbb-menu][open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); }); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseAll); else initialiseAll();
  document.addEventListener('shopify:section:load', initialiseAll);
})();
